export const PASSWORD_REUSED_MESSAGE = "Sua nova senha deve ser diferente das utilizadas anteriormente";
export const INVALID_RESET_TOKEN_MESSAGE =
  "Este link para redefinição de senha é inválido, expirou ou já foi utilizado. Solicite um novo link.";

export function isPasswordValid(password: string, username: string): boolean {
  if (!password || !username) return false;
  const lowerPassword = password.toLowerCase();

  // verifica o nome do usuário, dividido por espaços, ignorando partes com menos de 3 caracteres
  const nameFragments = username.toLowerCase().trim().split(/\s+/);
  for (const part of nameFragments) {
    if (part.length >= 3 && lowerPassword.includes(part)) {
      return false;
    }
  }

  // Verifica palavras proibidas
  const bannedWords = ["sinqia", "evertec", "quiteja"];
  if (bannedWords.some((word) => lowerPassword.includes(word))) {
    return false;
  }

  // Verifica sequências numéricas crescentes ou decrescentes com 3+ dígitos
  const sequences = ["0123456789", "9876543210"];
  for (const seq of sequences) {
    for (let i = 0; i <= seq.length - 3; i++) {
      const pattern = seq.substring(i, i + 3);
      if (password.includes(pattern)) {
        return false;
      }
    }
  }

  // verificar sequencia de caracteres(abc, def, etc)
  const alphabet = "abcdefghijklmnopqrstuvwxyz";
  for (let i = 0; i < alphabet.length - 2; i++) {
    const pattern = alphabet.substring(i, i + 3);
    if (
      lowerPassword.includes(pattern) ||
      lowerPassword.includes(pattern.split("").reverse().join(""))
    ) {
      return false;
    }
  }

  return true;
}

export function isPasswordValidWithoutName(password: string): boolean {
  if (!password) return false;
  const lowerPassword = password.toLowerCase();

  // Verifica palavras proibidas
  const bannedWords = ["sinqia", "evertec", "quiteja"];
  if (bannedWords.some((word) => lowerPassword.includes(word))) {
    return false;
  }

  // Verifica sequências numéricas crescentes ou decrescentes com 3+ dígitos
  const sequences = ["0123456789", "9876543210"];
  for (const seq of sequences) {
    for (let i = 0; i <= seq.length - 3; i++) {
      const pattern = seq.substring(i, i + 3);
      if (password.includes(pattern)) {
        return false;
      }
    }
  }

  const alphabet = "abcdefghijklmnopqrstuvwxyz";
  for (let i = 0; i < alphabet.length - 2; i++) {
    const pattern = alphabet.substring(i, i + 3);
    if (
      lowerPassword.includes(pattern) ||
      lowerPassword.includes(pattern.split("").reverse().join(""))
    ) {
      return false;
    }
  }

  return true;
}
